import { jsx } from "react/jsx-runtime";
import { Box, Link, Text } from "braid-design-system";
import { useLink } from "../../../ApacCandidateFooter/components/Accordion/Accordion.mjs";
import { link } from "./EmployersLink.css.mjs";
const EmployersLink = ({ href, linkContext, text }) => {
  const { injectLinkContextToData } = useLink();
  return /* @__PURE__ */ jsx(Box, { display: "flex", alignItems: "center", height: "full", children: /* @__PURE__ */ jsx(
    Link,
    {
      className: link,
      href,
      data: injectLinkContextToData(linkContext, {
        automation: "employers_link"
      }),
      children: /* @__PURE__ */ jsx(Text, { weight: "medium", tone: "formAccent", size: "small", children: text })
    }
  ) });
};
export {
  EmployersLink
};
